var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCreditCardX2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.0002 15C11.0002 14.4477 11.448 14 12.0002 14H12.2502C12.8025 14 13.2502 14.4477 13.2502 15C13.2502 15.5523 12.8025 16 12.2502 16H12.0002C11.448 16 11.0002 15.5523 11.0002 15Z",
    className: "Icon-fill-color",
    stroke: "transparent"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.0002 15C15.0002 14.4477 15.448 14 16.0002 14H17.5002C18.0525 14 18.5002 14.4477 18.5002 15C18.5002 15.5523 18.0525 16 17.5002 16H16.0002C15.448 16 15.0002 15.5523 15.0002 15Z",
    className: "Icon-fill-color",
    stroke: "transparent"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.998047 7C0.998047 5.34315 2.34119 4 3.99805 4H19.998C21.6549 4 22.998 5.34315 22.998 7V17C22.998 18.6569 21.6549 20 19.998 20H3.99805C2.34119 20 0.998047 18.6569 0.998047 17V7ZM20.998 8.5H2.99805V7C2.99805 6.44772 3.44576 6 3.99805 6H19.998C20.5503 6 20.998 6.44772 20.998 7V8.5ZM20.998 10.5H2.99805V17C2.99805 17.5523 3.44576 18 3.99805 18H19.998C20.5503 18 20.998 17.5523 20.998 17V10.5Z",
    className: "Icon-fill-color",
    stroke: "transparent"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreditCardX2);
export default __webpack_public_path__ + "static/media/CreditCardX2.8c09cfe8ac2a5239260c169d8b0dae81.svg";
export { ForwardRef as ReactComponent };